import { render, staticRenderFns } from "./editSendShopp.page.vue?vue&type=template&id=e2d1fe96&scoped=true&"
import script from "./editSendShopp.page.vue?vue&type=script&lang=js&"
export * from "./editSendShopp.page.vue?vue&type=script&lang=js&"
import style0 from "./editSendShopp.page.vue?vue&type=style&index=0&id=e2d1fe96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d1fe96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2d1fe96')) {
      api.createRecord('e2d1fe96', component.options)
    } else {
      api.reload('e2d1fe96', component.options)
    }
    module.hot.accept("./editSendShopp.page.vue?vue&type=template&id=e2d1fe96&scoped=true&", function () {
      api.rerender('e2d1fe96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/sendShop/editSendShopp.page.vue"
export default component.exports